<template id="app">
  <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <!-- Alert message -->
    <div>
      <v-alert :type="alert_type" :value="alert" :model-value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <!-- Header-->
    <header-component :headerTitle="headerText" />
    <v-snackbar
      v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :location="snackbar.position === 'top' ? 'top' : 'bottom'">
      <v-layout align-center pr-4>
        <v-icon class="pr-3 ml-2" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
    <!-- Dialog popup -->
    <v-row justify="center" style="margin-left: 20px;">
      <v-dialog v-model="download_dialog" persistent max-width="350px">
        <v-card class="v-card-100">
            <v-card-title class="mb-5 d-flex">
              <span>Download</span>
              <v-spacer></v-spacer>
              <v-btn icon variant="solo" @click="download_dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
          <v-divider :thickness="2" class="border-opacity-50 m-0"/>
          <v-card-text>
            <div>
              <v-row style="margin-left: 20px;">
            <v-col cols="6"> 
              <input type="radio" id="option1" class="custom-radio" value="download_csv" v-model="selectFormatType">
                 <label class="custom-label" for="option1">CSV</label>
            </v-col>
            <v-col cols="6"> 
              <input type="radio" id="option2" class="custom-radio" value="download_xls" v-model="selectFormatType">
                <label class="custom-label" for="option2">XLS</label>
            </v-col>
          </v-row>
            </div>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn small variant="outlined" color="primary" class="text-none" @click="download_dialog = false">Cancel</v-btn>
            <v-btn small color="primary" variant="flat" @click="downloadFile" class="text-none" :disabled="!selectFormatType || number > 0">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Download popup -->
    <v-row justify="center">
      <v-dialog v-model="downloadDialog" persistent max-width="364px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex">
            <span>Download</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="downloadDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="2" class="border-opacity-50 m-0"/>
            <v-card-text class="download-email">
              <v-row>
                <v-col cols="12" sm="4" md="12">
                  <v-text-field label="Email Id" :rules="emailRules" @input="validateEmail" variant="outlined"  v-model="email_id" type="text"></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="outlined" class="text-none" size="large" color="primary" @click="downloadDialog = false">Cancel</v-btn>
            <v-btn variant="flat" class="text-none" size="large" color="primary" @click="downloadFile('submit')" :disabled="!isEmailValid || number > 0">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- item details popup -->
    <v-row justify="center">
      <v-dialog v-model="detailsPopup" persistent max-width="700px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span>Address Details</span>
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="detailsPopup = !detailsPopup">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="2" class="border-opacity-50 m-0"/>
          <v-card-text>
            <v-container>
              <div>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Address</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.address ? item_details.address : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">State</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.state ? item_details.state : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Country</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.country ? item_details.country : '-' }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <span style="font-weight: 500;">Pin Code</span>
                  </v-col>
                  <v-col cols="6">
                    {{ item_details.pin_code ? item_details.pin_code : '-' }}
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- filter data popup -->
    <v-row justify="center">
      <v-dialog content-class="filter-dispatch" v-model="filteWithSubPopup" persistent :max-width="organization_name === 'Voltas' ? '1224px' : '600px'">
        <v-card class="filter_ui">
          <v-card-actions>
            <v-row class="mt-2">
              <v-col :cols="organization_name === 'Voltas' ? '3' : '6'">
              <v-combobox prepend-inner-icon="mdi-magnify" clearable v-model="role" :items="roleItems" multiple item-title="name" item-value="id" label="Mapped Roles" variant="outlined" max-width="300px"> </v-combobox>
              </v-col>
              <v-col cols="3" v-if="organization_name === 'Voltas'">
              <v-combobox prepend-inner-icon="mdi-magnify" clearable v-model="type_of_users" :items="type_users_items" multiple label="Type Of Users" variant="outlined" > </v-combobox>
              </v-col>
              <v-col cols="3" v-if="organization_name === 'Voltas'">
                <v-combobox v-model="branch" :items="branch_items" label="Branch" variant="outlined" multiple clearable> </v-combobox>
              </v-col>
              <v-col :cols="organization_name === 'Voltas' ? '3' : '6'">
                <v-combobox v-model="organizations" :items="organizations_items"  label="Organization" variant="outlined" multiple clearable> </v-combobox>
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn class="text-none" size="small" variant="outlined" color="primary" @click="filteWithSubPopup = false">Cancel</v-btn>
            <v-btn class="text-none" size="small" variant="flat" color="primary" @click="applyFilter('filter')">Apply Filter(S)</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-card class="v-card-100 mt-6">
      <v-tabs v-model="tab_index">
        <v-tab class="component-tab-heading" ripple :href="'#'" @click="loadData(tab, 'tab_clicked')"
          style="text-transform:none!important;text-decoration: none;" v-for="(tab, index) in tabs"
          :key="index">{{ tab }}</v-tab>
      </v-tabs>
    </v-card>
    <!-- seacrh, action button and filter -->
    <v-card-title style="padding: 25px 25px 15px 15px;" class="action-style pb-0">
      <!-- Search fields -->
      <v-row class="ma-1">
        <v-autocomplete color="primary" v-model="select_field" :items="select_field_items" label="Select Field" variant="outlined" style="max-width: 158px;" class="mr-4 text-left"> </v-autocomplete>
        <v-text-field color="primary" prepend-inner-icon="mdi-magnify" v-model="search_tag" v-no-edge-space label="Search" style="max-width: 270px;" variant="outlined" v-on:keyup.enter="applyFilter('search')" :disabled="!select_field"></v-text-field>
          <v-spacer></v-spacer>
        <v-card-actions class="mb-4">
          <v-btn class="mr-2 custum-button text-none" variant="flat" 
            :disabled="selected.length === 0 || !disabledSelected || !selected.every(item => !item.is_active) || selected.some(item => item.is_active)" 
            @click="updateUserStatus(true)" color="primary" large 
            style="min-height:55px; min-width:130px; font-weight:600;">
            Enable
          </v-btn>
          <v-btn class="mr-2 custum-button text-none" variant="flat" 
            :disabled="selected.length === 0 || !disabledSelected || !selected.every(item => item.is_active) || selected.some(item => !item.is_active)" 
            @click="updateUserStatus(false)" color="primary" large 
            style="min-height:55px; min-width:130px; font-weight:600;">
            Disable
          </v-btn>
          <v-btn class="mr-2 custum-button text-none" variant="flat" v-if="selected.length > 0" @click="downloadFile('selected')" color="primary" large style="min-height:55px; min-width:130px; font-weight:600;">Download</v-btn>
          <v-btn class="mr-2 custum-button text-none" variant="flat" v-if="selected.length === 0" @click="openPopup" color="primary" large style="min-height:55px; min-width:130px; font-weight:600;">Download</v-btn>
          <v-btn class="mr-2 custum-button text-none" variant="flat" :disabled="(selected.length === 1)" @click="navigateToFileUpload" color="primary" large style="min-height:55px; min-width:100px; font-weight:600;">Upload</v-btn>
          <v-btn class="mr-2 custum-button text-none" variant="flat" :disabled="selected.length === 0" @click="deleteUser"  color="primary" large style="min-height:55px; min-width:100px; font-weight:600;">Delete</v-btn>
          <!-- <v-btn class="mr-2" :disabled="(selected.length === 1)" @click="navigateToAddLocationMaster('add')" color="primary">Add</v-btn> -->
          <!-- <v-btn class="mr-2" :disabled="(selected.length !== 1)" @click="navigateAdd()" color="primary">Edit</v-btn> -->
        </v-card-actions>
        <!-- Filter -->
        <v-expansion-panels class="custom-control_outlined m-0 pt-2" ref="filterPopupRef" readonly style="max-width: 300px; margin-bottom: 28px; height: 56px;">
          <v-expansion-panel variant="outlined" @click="filterListOfButtons">
            <v-expansion-panel-title>Filter
            </v-expansion-panel-title>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
    </v-card-title>
    <!-- tabs data -->
    <v-layout column>
      <!-- <v-flex md6 style="overflow: auto"> -->
        <v-data-table hover
          density="compact"
          :search="search"
          v-model="selected"
          show-select
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="table_data"
          :loading="loading"
          :items-per-page="pageSize"
          fixed-header
          height="100%"
          loading-text="Loading Data... Please wait" 
          class="elevation-1"
          return-object
          >
          <template v-slot:[`item.${headers.key}`]="{ item }" v-for="headers in headers">
              <span v-if="headers.key == 'view_address'">
                <a href="#" @click.prevent="itemDetailPopup(item)" style="text-decoration: underline !important; color: #1976d2 !important; cursor: pointer !important;">{{ item.view_address }}</a>
              </span> 
              <span v-else-if="headers.key == 'role'">
                <u>{{ getFirstRole(item.role) }}</u>
              </span>
              <span v-else-if="headers.key == 'is_active'">
                <span :style="{ color: item.is_active === true ? 'green' : item.is_active === false ? 'red' : 'black' }">
                  {{ item.is_active === true ? 'Enable' : item.is_active === false ? 'Disable' : '-' }}
                </span>
              </span>
              <span v-else-if="item[headers.key]">
                <GlobalTooltip :text="item[headers.key]" />
                </span>
                <span v-else>-</span>
            </template>
          <template #bottom></template>
        </v-data-table>
      <!-- </v-flex> -->
    </v-layout>
    <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-0"
                />
    
  </v-card>
</template>
<script>
  import HeaderComponent from '../../../../commoncomponents/HeaderComponent.vue';
  import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
  export default {
    components : {
      HeaderComponent
    },
    data(){
      return {
        headerText: "User Master",
        alert : false,
        alert_type : "success",
        alert_message : '',
        search_tag: '',
        loading : false,
        selected:[],
        headers : [],
        table_data : [],
        search  : '',
        filteWithSubPopup: false,
        download_dialog: false,
        selectFormatType:'',
        number: 0,
        page: 1,
        totalPages: 1,
        totalCount: '',
        pageSize: defaultPageSize,
        pageSizes: defaultPageSizes,
        role : null,
        designation : [],
        branch : null,
        roleItems: [], 
        designation_items: [], 
        branch_items: [], 
        detailsPopup: false,
        item_details: '',
        tabs:[
          "User Master",
          "User Mapping"
        ],
        active_tab: "User Master",
        select_field_items:[],
        select_field:null,
        snackbar: false,
        download_message: '',
        snackbarColor:'',
        tab_index: 0,
        active_tab_condi:'',
        type_of_users:null,
        isFiltering : false,
        isSearchFiltering: false,
        type_users_items:[],
        downloadDialog:false,
        email_id:'',
        organizations_items:'',
        organizations:null,
        email_format_rule: [
          v => (/^[\w,.]+([\.-]?[\w,.]+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email_id)) || "Please enter valid Email"
        ],
        isEmailValid:true,
        emailError:'',
        snackbar: {
          color: null,
          icon: null,
          mode: null,
          position: "top",
          text: null,
          timeout: 7500,
          title: null,
          visible: false
        },
        organization_name:''
      }
    },
    async created(){
      this.active_tab_condi = this.$store.state.active_tab;
      this.headerTextSub = this.$store.state.inventoryId;
      this.download_message = this.$store.state.lotIds;
      this.organization_name = this.$store.state.organization_name;
      if(this.active_tab_condi === 'first_tab'){
        this.tab_index = 0;
        this.loadData('User Master');
      }else if(this.active_tab_condi === 'second_tab'){
        this.tab_index = 1;
        this.loadData('User Mapping');
      }else{
        this.loadData('User Master');
      }
    },
    computed: {
      emailRules() {
        return [
          v => this.emailError || true
        ];
      },
      disabledSelected() {
        const uniqueSelected = [...new Set(this.selected.map(item => item.is_active))];
        if(uniqueSelected.length >1){
          this.snackbar = true;
          this.snackbar = {
               color: "error",
               icon: "mdi-close-circle",
               mode: "multi-line",
               position: "bottom",
               timeout: 3000,
               title: 'Success',
               text: "Can't select different status for enable/disable users",
               visible: true
              };
          return false
        }else{
          return true
        }
      }
    },
    methods: {
      showAlert(alert_type, alert_message) {
        this.alert = true;
        this.alert_type = alert_type;
        this.alert_message = alert_message;
        this.scrollToTop();
        this.alertTimeOut();
      },
      alertTimeOut() {
        setTimeout(() => {
            this.alert = false;
        }, 3000);
      },
      scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      },
      loadData(tab,tab_action){
        if(tab_action){
          this.search_tag = '';
          this.select_field = null;
        }
        // this.download_message = ''
        this.loading = false;
        this.isFiltering = false;
        this.isSearchFiltering = false;
        this.selected = []
        this.active_tab = tab
        this.table_data = []
        this.page = 1
        this.totalPages = 1
        this.successPopup = false;
        if (tab == "User Master"){
          this.$store.commit("setActiveTab", {
              active_tab:'first_tab'
          }); 
        this.headers = [
          { title: "Organization", key: "org_name"},
          { title: "User ID", key: "employee_code"},
          { title: "Name", key: "full_name" },
          { title: "Primary Mobile Number", key: "contact_no" },
          { title: "Alternate Mobile Number", key: "alternate_contact_no"},
          { title: "Status", key: "is_active"},
          { title: "Email ID", key: "email" },
          { title: "Designation", key: "designation" },
          { title: "Department/Function", key: "department" },
          { title: "User Type", key: "user_type" },
          { title: "Employer Organization", key: "user_organization"},
          { title: "Distribution Centers", key: "distribution_center_ids"},
          { title: "Address", key: "view_address" },
          { title: "Branch", key: "branch"},
          { title: "Mapped Roles", key: "roles" }
        ];
        this.select_field_items = [
          "User ID",
          "Name",
          "Primary Mobile Number",
          "Email ID",
          "Designation",
          "Department/Function",
          "Employer Organization"
        ];
        if (this.$isRelianceClient()) {
          const fieldsToRemove = ["user_organization", "branch", "user_type"];
            this.headers = this.headers.filter(header => !fieldsToRemove.includes(header.key));
            this.select_field_items = this.select_field_items.filter(item => item !== "Employer Organization" && item !== "Branch" && item !== "User Type");
          }else if(this.organization_name === "Voltas"){
            const fieldsToRemove = ["distribution_center_ids"];
            this.headers = this.headers.filter(header => !fieldsToRemove.includes(header.key));
          }
        this.getUsers();
        }
        if(tab == "User Mapping"){
          this.$store.commit("setActiveTab", {
            active_tab:'second_tab'
          });
          this.headers = [
            { title: "User ID", key: "employee_code"},
            { title: "User E-Mail ID", key:"email"},
            { title: "Reporting Manager", key: "reporting_manager"},
            // { title: "Tour Plan Approver", key: "tour_plan_manager"}
          ];
          this.select_field_items = [
          "User ID",
          "Reporting Manager"];
          this.getUsers();
        }        
      },
      getUsers() {
        this.loading = true;
        const params ={
          search : this.search_tag,
          page: this.page,
          per_page: this.pageSize,
        }
        let end_point = this.organization_name === "Voltas" ? '/api/v2/users/users_index' : '/api/v2/users'
        this.$httpSecured
          .get(end_point,{params : params})
          .then(response => {
            if (response.data) {
              this.table_data = response.data.users.map(user => {
                return {
                  ...user,
                  roles: user.roles.join(', '),
                  ...(this.organization_name !== "Voltas" && {
                    distribution_center_ids: user.distribution_center_ids.join(','),
                  }),                  
                  view_address:'View Address'
                };
              });
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count;
              // this.$store.commit("setActiveTab", {});
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", error.response.data.error);
            this.loading = false;
          });
      },
      getFirstRole(roles) {
        return Array.isArray(roles) && roles.length > 0 ? roles[0] : '';
      },
      itemDetailPopup(item){
        this.detailsPopup = true
        this.item_details = item;
      },
      filterListOfButtons() {
        this.filteWithSubPopup = true;
        this.role = null,
        this.type_of_users = null,
        this.branch = null,
        this.organizations = null,
        document.documentElement.style.setProperty('--dialog-ypos', (this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 40).toString() + 'px');
        this.getFilter()
      },
      getFilter(){
        this.$httpSecured
          .get('/api/v2/users/filter_options')
          .then(response => {
            if (response.data) {
              this.roleItems = this.transformRoles(response.data.roles);
              this.organizations_items = response.data.organizations
              this.branch_items = response.data.branches
              this.type_users_items = response.data.user_type
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      transformRoles(roles) {
        return roles.map(role => ({
          id: role[0],
          name: role[1],
        }));
      },
      transformUserType(userType) {
        return userType.map(type => (type === 'Client' || type === 'Internal' ? 'Internal' : type));
      },
      downloadPopup(){
        this.download_dialog = true;
        this.selectFormatType = '';
        this.number = 0;
      },
      navigateToFileUpload() {
        if(this.active_tab === 'User Master'){
          this.$store.commit("setLotIds", {
          lotIds: this.headerText,
          inventoryId: "User Master",
          action:'first_tab'
        });
        }else if(this.active_tab === "User Mapping"){
          this.$store.commit("setLotIds", {
          lotIds: this.headerText,
          inventoryId: "User Mapping",
          action:'second_tab'
        });
        }        
        this.$router.push({ name: "LotFileuploadComm" });
      },
      navigateToAddLocationMaster(condition) {
        if(condition === 'add'){
          this.$store.commit("setLotIds", {
            lotIds: "",
            action: condition,
            inventoryId: 'User Master'
          });
        }
        this.$router.push({ name: "addEditMaster" });
      },
      navigateAdd(){
        this.$store.commit("setLotIds", {
          lotIds: this.selected,
          action: 'edit',
          inventoryId: 'User Master'
        });
        this.$router.push({ name: "addEditMaster" });
      },
      handlePageSizeChange(size){
        this.pageSize = size;
        this.page = 1
        if(this.isSearchFiltering){
          this.applyFilter('search');
          return;
        }else if(this.isFiltering){
          this.applyFilter('filter');
          return;
        }
        this.getUsers()
      },
      handlePageChange(value) {
        this.page = value;
        if(this.isFiltering){
          this.filterPage = value;
          this.applyFilter('filter');
          return;
        }else if(this.isSearchFiltering){
          this.applyFilter('search');
          return;
        }
        this.getUsers()
      },
      openPopup(){
        this.downloadDialog = true;
        this.email_id = this.$store.state.currentUser.email;
        this.validateEmail(this.email_id)
      },
      downloadFile(value) { 
        this.number++;
        const formData = new FormData();
        if(value === 'submit'){
          formData.append('email_ids', this.email_id);
        }else{
           const ids = this.selected.map(item => item.id);
          ids.forEach(id => formData.append('user_ids[]', id));
        }         
         let url;
         if(this.active_tab === 'User Mapping'){
           url = "/api/v2/users/download_user_info?file_type=User Configuration"
         }else if(this.active_tab === 'User Master'){
          url = "/api/v2/users/download_user_info"
         }
        this.$httpSecured
          .post(url, formData)
          .then(response => {
              if (response.data) {
               if(value === 'submit'){
               this.snackbar = true;
               this.downloadDialog = false;
               this.email_id='';
              this.snackbar = {
                    color: "success",
                    icon: "mdi-check-circle",
                    mode: "multi-line",
                    position: "top",
                    timeout: 3000,
                    title: 'Success',
                    text: response.data.message,
                    visible: true
                  };
            }else{
             const url = response.data.url;
              const link = document.createElement('a');
              link.href = url;
              link.download = '';
              document.body.appendChild(link);
              link.click();
              this.snackbar = {
                      color: "success",
                      icon: "mdi-check-circle",
                      mode: "multi-line",
                      position: "top",
                      timeout: 3000,
                      title: "Success",
                      text: "(CSV File) Downloaded Successfully",
                      visible: true
                    };
              } 
                  this.selected = [];
                  this.number = 0;
              } else {
                  this.loading = false;
                  this.showAlert("error", "No Data Found");
                  this.number = 0;
              }
          })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
          this.number = 0;
        });
      },
      downloadImage(url) {
        let a = document.createElement('a');
        a.download = url
        a.href = url;
        document.body.appendChild(a);
        a.click();
        a.remove();
      },
     applyFilter(value) {
        this.loading = true;   
        this.isFiltering = false;
        this.isSearchFiltering = false;     
        const payload = {
            page: this.page,
            per_page: this.pageSize,
            filter: {}
          };

        if (value === 'filter') {
          this.isFiltering = true;
          this.select_field = null;
          this.search_tag = '';
          payload.filter['user_type'] = this.type_of_users;
          payload.filter['branch'] = this.branch;
          payload.filter['organization'] = this.organizations;
          if (Array.isArray(this.role) && this.role.length > 0) {
            payload.filter['role'] = this.role.map(role => role.id);
          }
        } else if(value == 'search'){
          this.isSearchFiltering = true;
          if (this.select_field === 'User ID') {
            payload.filter['employee_code'] = this.search_tag;
          } else if (this.select_field === 'Name') {
            payload.filter['first_name'] = this.search_tag;
          } else if (this.select_field === 'Primary Mobile Number') {
            payload.filter['contact_no'] = this.search_tag;
          } else if (this.select_field === 'Email ID') {
            payload.filter['email'] = this.search_tag;
          } else if (this.select_field === 'Designation') {
            payload.filter['designation'] = this.search_tag;
          } else if (this.select_field === 'Department/Function') {
            payload.filter['department'] = this.search_tag;
          } else if (this.select_field === 'Reporting Manager') {
            payload.filter['reporting_manager'] = this.search_tag;
          } else if(this.select_field === 'Employer Organization'){
            payload.filter['user_organization'] = this.search_tag;
          }
        }
        let end_point = '/api/v2/users/index_new';
        this.$httpSecured
          .post(end_point, payload)
          .then(response => {
            if (response.data) {
              this.table_data = response.data.users.map(user => {
                return {
                  ...user,
                  roles: user.roles.join(', '),
                  ...(this.organization_name !== "Voltas" && {
                    distribution_center_ids: user.distribution_center_ids.join(','),
                  }),
                  view_address:'View Address'
                };
              });
              this.filteWithSubPopup = false;
              this.totalPages = response.data.meta.total_pages;
              this.totalCount = response.data.meta.total_count;
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
      },
      afterClickOK(){
        this.snackbar = false
        this.$store.commit("setLotIds", {});
        this.loadData(this.active_tab)
        },
      validateEmail() {
        const emails = this.email_id.split(',').map(email => email.trim());
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emails.length === 1 && !emailPattern.test(emails[0])) {
          this.emailError = 'Please enter a valid email';
          this.isEmailValid = false
          return;
        }else{
          this.isEmailValid = true
        }

        for (const email of emails) {
          if (!emailPattern.test(email)) {
            this.emailError = 'Please enter valid email ids separated by commas';
            this.isEmailValid = false
            return;
          }else{
            this.isEmailValid = true
          }
        }     

        this.emailError = null;
      },
      deleteUser() {
        // const ids = this.selected.id.join(',')
        var dc = this.selected.map(x => x.id).join(',')
        this.$httpSecured
          .delete(`/api/v2/users/${dc}`)
          .then(response => {
            if (response.data) {
              // this.showAlert("success", "Successfully deleted");
              this.snackbar = true;
              this.snackbar = {
                    color: "success",
                    icon: "mdi-check-circle",
                    mode: "multi-line",
                    position: "top",
                    timeout: 3000,
                    title: 'Success',
                    text: "Successfully deleted",
                    visible: true
                  };
              this.loadData(this.active_tab);
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
        },
      formatLogisticPartner(partnerString) {
        if (partnerString && typeof partnerString === 'string') {
          const match = partnerString.match(/^\["(.*?)"\]\s*(.*)$/);
          if (match && match[1]) {
            return `${match[1]} ${match[2] || ''}`.trim();
          }
        }
        return partnerString || '-';
      },
        updateUserStatus(status) {
          const userIds = this.selected.map(user => user.id);
          const payload = {
            users: {
              ids: userIds,
              is_active: status
            }
          };

          this.$httpSecured.post('/api/v2/users/update_status', payload)
            .then(response => {
              if (response.data) {
                this.snackbar = {
                  color: "success",
                  icon: "mdi-check-circle",
                  mode: "multi-line",
                  position: "bottom",
                  timeout: 3000,
                  title: 'Success',
                  text: `Users successfully ${status ? 'enabled' : 'disabled'}`,
                  visible: true
                };
                this.loadData(this.active_tab);
              } else {
                this.showAlert("error", "Failed to update user status");
              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
            });
        },
    }
  }
</script>
<style scoped>
  .v-dialog:has(.filter-dispatch) {
    justify-content: right;
    align-items: baseline;
    top: var(--dialog-ypos);
  }

  .v-dialog>.v-card>:has(.v-card__title) {
    overflow-wrap: break-word !important;
  }

  .custom-control_outlined .v-expansion-panel:before {
    box-shadow: none;
  }

  .custom-control_outlined button {
    min-height: 56px;
    border-width: 1px;
    border-color: rgba(0, 0, 0, .42);
    border-style: solid;
  }

  .custom-control_outlined button:focus {
    outline: none;
  }
    
  .item-selected{
    margin-top: 23px;
    position: absolute;
    left: 41%;
  }
  @media (max-height: 1104px) {
    .PaddingItemPerPage{
      padding: 8px !important;
    }
  }
  @media (min-height: 1126px) {
    .PaddingItemPerPage{
      padding: 24px !important;
    }
}
.v-data-table {
  height: calc(var(--vh, 1vh) * 100 - 325px) !important;
}
.filter_ui{
  margin-right: 20px !important;
  margin-top: 12px !important;
}
</style>
